<script setup>
import {onMounted, ref} from "vue";
import {useI18n} from "vue-i18n";
import {formatAmount} from "@/helper";
import StrategyService from "@/services/StrategyService";

/**
 * IMA-517: karta Souhrn na detailu strategie typu BOND v administraci – vedle Základních informací,
 * tabulka dluhopisů je pod horními kartami zvlášť (StrategyBondsCard). Data z api/strategies/{id}/bonds-summary.
 */
const props = defineProps({
  strategyId: {type: [Number, String], required: true},
});

const {t} = useI18n();
const summary = ref(null);

onMounted(() => {
  StrategyService.getBondsSummary(props.strategyId).then(response => {
    summary.value = response;
  });
});
</script>

<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header__title">{{ t('strategiesDetail.bonds.summary') }}</div>
    </div>
    <div class="card-body">
      <!-- klienti a objem jen z aktivních držeb (BE: ClientBond::scopeWhereActive) -->
      <div v-if="summary" class="row g-2">
        <div class="col-6">
          <div class="card card--flat card--big-value h-100">
            <div class="card-body py-0 d-flex flex-column justify-content-center">
              <span class="card__value__label">{{ t('strategiesDetail.bonds.bonds_count') }}</span>
              <div class="card__value">{{ summary.bonds_count }}</div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card card--flat card--big-value h-100">
            <div class="card-body py-0 d-flex flex-column justify-content-center">
              <span class="card__value__label">{{ t('strategiesDetail.bonds.on_sale_count') }}</span>
              <div class="card__value">{{ summary.on_sale_count }}</div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card card--flat card--big-value h-100">
            <div class="card-body py-0 d-flex flex-column justify-content-center">
              <span class="card__value__label">{{ t('strategiesDetail.bonds.clients_count') }}</span>
              <div class="card__value">{{ summary.clients_count }}</div>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="card card--flat card--big-value h-100">
            <div class="card-body py-0 d-flex flex-column justify-content-center">
              <span class="card__value__label">{{ t('strategiesDetail.bonds.nominal_volume') }}</span>
              <!-- objem po měnách (dluhopisy mohou být v CZK i EUR); starší BE bez nominal_volumes – součet jako CZK -->
              <template v-if="summary.nominal_volumes">
                <div v-for="volume of summary.nominal_volumes" :key="volume.currency" class="card__value">{{ formatAmount(volume.amount, volume.currency, 0) }}</div>
                <div v-if="!summary.nominal_volumes.length" class="card__value">{{ formatAmount(0, 'CZK', 0) }}</div>
              </template>
              <div v-else class="card__value">{{ formatAmount(summary.nominal_volume, 'CZK', 0) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
